import Loadable from 'react-loadable';

const ReturnFromPopUpAuth = Loadable<any, any>({
  loader: () => import(/* webpackChunkName: "ReturnFromPopUpAuth" */ './ReturnFromPopUpAuth'),
  loading: () => null,
});

export default ReturnFromPopUpAuth;
